import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import ContactModal from '../components/contact-modal'
import Footer from '../components/footer'
import Mark from '../components/mark'
import FAQ from '../components/faq'
import './home.css'

const ActiveSourcing = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false)
  const [buttonSource, setButtonSource] = useState('')

  const openContactModal = (source = 'Unbekannt') => {
    setButtonSource(source)
    setIsContactModalOpen(true)
  }

  const closeContactModal = () => {
    setIsContactModalOpen(false)
  }

  return (
    <div className="home-container1">
      <Helmet>
        <title>Active Sourcing Berlin | Proaktive Kandidatenansprache für Ihr Unternehmen</title>
        <meta name="description" content="Professionelles Active Sourcing in Berlin: Finden und gewinnen Sie passive Kandidaten durch proaktive Direktansprache. Ihre Experten für erfolgreiches Active Sourcing auf LinkedIn und Social Media." />
        <meta property="og:title" content="Active Sourcing Berlin | Proaktive Kandidatenansprache" />
        <meta property="og:description" content="Ihre Experten für Active Sourcing in Berlin. Wir finden und sprechen die besten Talente direkt an – auch wenn sie nicht aktiv auf Job-Suche sind." />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name" onContactClick={openContactModal}></Navbar>

      <section className="home-section10">
        <div className="home-hero">
          <div className="home-content1">
            <main className="home-main1">
              <header className="home-header10" >
                <h1 className="home-heading10">
                  Active Sourcing: Finden Sie die besten Talente, bevor Ihre Konkurrenz es tut
                </h1>
                <span className="home-caption1">
                  Als spezialisierte Social Recruiting Agentur in Berlin helfen wir Ihnen bei der proaktiven Kandidatenansprache. Mit professionellem Active Sourcing erreichen Sie passive Kandidaten auf LinkedIn, XING und anderen Plattformen – und gewinnen Fachkräfte, die nie auf Ihre Stellenanzeige geantwortet hätten.
                </span>
              </header>
              <div className="home-buttons1">
                <div className="home-get-started1 button" onClick={() => openContactModal('Active Sourcing starten')} style={{ cursor: 'pointer' }}>
                  <span className="home-text10">Active Sourcing starten</span>
                </div>
              </div>
            </main>
          </div>
          <div className="home-image13">
            <img
              alt="Active Sourcing Berlin"
              src="/social-media-recruiting-agentur-gezielt.png"
              className="home-image14"
            />
          </div>
        </div>
      </section>

      <section className="home-section11" style={{ marginTop: '80px' }}>
        <h2 className="home-text12">
          Was ist Active Sourcing und warum ist es so erfolgreich?
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Die proaktive Kandidatenansprache als Antwort auf den Fachkräftemangel
              </h2>
              <p className="home-paragraph1">
                <span>
                  Active Sourcing bezeichnet die proaktive, direkte Ansprache potenzieller Kandidaten durch Recruiter. Im Gegensatz zum traditionellen Post-and-Pray-Ansatz – eine Stellenanzeige schalten und warten, dass sich jemand bewirbt – gehen Sie beim Active Sourcing aktiv auf die Suche nach geeigneten Kandidaten und sprechen diese direkt an. Als Social Recruiting Agentur in Berlin sind wir Experten für diese moderne Form der Mitarbeitergewinnung, die besonders im Kampf gegen den Fachkräftemangel entscheidende Vorteile bietet.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der große Vorteil von Active Sourcing liegt in der Reichweite: Studien zeigen, dass 70-80% der qualifizierten Fachkräfte nicht aktiv auf Job-Suche sind, aber offen für neue Chancen wären. Diese passiven Kandidaten erreichen Sie mit traditionellen Stellenanzeigen nicht – sie schauen nicht auf Jobbörsen, sie bewerben sich nicht proaktiv. Durch Active Sourcing können Sie genau diese Talente ansprechen und für Ihr Unternehmen gewinnen. Gerade in umkämpften Märkten wie IT, Engineering oder Healthcare ist Active Sourcing oft der einzige Weg, überhaupt an qualifizierte Kandidaten zu kommen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Als Social Recruiting Agentur nutzen wir verschiedene Plattformen für Active Sourcing. LinkedIn ist die wichtigste Plattform, besonders für Fach- und Führungskräfte. Mit über 800 Millionen Nutzern weltweit und umfangreichen Suchfiltern ist LinkedIn ideal für die gezielte Kandidatensuche. Aber auch XING (besonders im DACH-Raum), GitHub (für Entwickler), Stack Overflow (für IT-Professionals) oder spezialisierte Fach-Communities eignen sich für Active Sourcing. Die Kunst liegt darin, die richtige Plattform für Ihre Zielgruppe zu identifizieren und dort professionell zu recherchieren und anzusprechen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Active Sourcing ist mehr als nur das Versenden von InMails. Erfolgreiches Active Sourcing erfordert eine strukturierte Vorgehensweise: gründliche Recherche und Identifikation geeigneter Kandidaten, personalisierte, wertschätzende Ansprache, professionelles Follow-up und Beziehungsaufbau, sowie Integration in Ihren gesamten Recruiting-Prozess. Als spezialisierte Social Recruiting Agentur in Berlin beherrschen wir alle diese Disziplinen und haben bereits hunderte erfolgreiche Active Sourcing Projekte umgesetzt.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('Active Sourcing Strategie')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">Active Sourcing Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Active Sourcing Strategie"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Der Active Sourcing Prozess: Von der Recherche zur erfolgreichen Besetzung</h2>
          <span className="home-text26">
            Als erfahrene Social Recruiting Agentur in Berlin führen wir Sie durch alle Phasen des Active Sourcing – von der Strategie bis zur erfolgreichen Einstellung.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Kandidaten-Recherche"
              src="/social-media-recruiting-agentur-funktion.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Recherche & Identifikation</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Wie wir die perfekten Kandidaten für Ihre Position finden
                </h2>
                <p className="section-description">
                  Der erste Schritt jedes Active Sourcing Projekts ist die gründliche Recherche. Als Social Recruiting Agentur beginnen wir mit der Erstellung eines detaillierten Kandidatenprofils: Welche fachlichen Qualifikationen sind erforderlich? Welche Soft Skills sind wichtig? Welcher Cultural Fit wird gesucht? Welche Karrierelevel sind relevant? Wo könnten passende Kandidaten aktuell arbeiten (Wettbewerber, ähnliche Branchen)? Diese Informationen sammeln wir in Briefings mit Ihrem Hiring Manager und HR-Team.
                  
                  Auf LinkedIn nutzen wir die umfangreichen Such- und Filteroptionen: Jobtitel und Keywords, Fähigkeiten und Endorsements, Branchen und Unternehmen, Standorte und Sprachen, Bildungsabschlüsse und Zertifikate. LinkedIn Recruiter, das Premium-Tool für Active Sourcing, bietet noch erweiterte Filtermöglichkeiten, wie die Suche nach ehemaligen Mitarbeitern bestimmter Unternehmen, nach Kandidaten, die in den letzten Monaten ihren Job gewechselt haben, oder nach Personen, die "Open to Work" signalisiert haben.
                  
                  Boolean Search ist eine fortgeschrittene Technik, die wir als Social Recruiting Agentur beherrschen. Durch Kombination von Suchbegriffen mit AND, OR, NOT und anderen Operatoren können wir sehr präzise Suchen durchführen. Beispiel: "Software Engineer" AND (Python OR Java) AND Berlin NOT "Senior" – findet Software Engineers mit Python oder Java Kenntnissen in Berlin, aber keine Seniors. Diese präzise Suche spart Zeit und führt zu besseren Kandidaten-Matches.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Kandidaten finden')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Kandidaten finden lassen</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Kandidaten-Ansprache"
              src="/social-media-recruiting-agentur-content.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Personalisierte Ansprache
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Die Kunst der überzeugenden Kandidatenansprache
                  </h2>
                  <p className="section-description">
                    Die Ansprache ist der kritischste Teil des Active Sourcing. Eine generische "Hi, wir haben eine tolle Position" Nachricht wird ignoriert. Als Social Recruiting Agentur mit jahrelanger Erfahrung wissen wir: Erfolgreiche Active Sourcing Nachrichten sind personalisiert, wertschätzend und relevant. Personalisierung beginnt schon bei der Anrede und Einleitung: Zeigen Sie, dass Sie das Profil des Kandidaten wirklich angeschaut haben. Beziehen Sie sich auf spezifische Aspekte ihrer Karriere, Projekte oder Fähigkeiten.
                    
                    Die Struktur einer erfolgreichen Active Sourcing Nachricht folgt einem bewährten Aufbau: Persönliche Anrede und Bezug zum Kandidaten ("Ich bin beeindruckt von Ihrem Projekt XY..."). Kurze Vorstellung Ihres Unternehmens und der Position. Konkrete Angabe, warum gerade dieser Kandidat interessant ist ("Ihre Expertise in Python und Machine Learning passt perfekt zu..."). Attraktive Aspekte der Position und des Unternehmens (ohne zu übertreiben). Klarer, niedrigschwelliger Call-to-Action ("Hätten Sie Interesse an einem unverbindlichen Austausch?").
                    
                    Der Ton macht die Musik: Ihre Nachricht sollte professionell, aber nicht zu formal sein. Wertschätzend, aber nicht übertrieben schmeichelhaft. Authentisch und transparent – falsche Versprechen fallen später auf und schaden Ihrer Arbeitgebermarke. Als Social Recruiting Agentur testen und optimieren wir kontinuierlich verschiedene Ansprache-Varianten und wissen, welche Formulierungen und Ansätze die höchsten Response-Raten erzielen.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Hochgradig personalisierte Direktansprache"></Mark>
                  <Mark label="Professionelle, wertschätzende Kommunikation"></Mark>
                  <Mark label="A/B-Testing für optimale Response-Raten"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Ansprache-Strategie')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Ansprache-Strategie entwickeln</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          LinkedIn Active Sourcing: Die wichtigste Plattform für Ihre Kandidatensuche
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie Sie LinkedIn optimal für Active Sourcing nutzen
              </h2>
              <p className="home-paragraph1">
                <span>
                  <strong>LinkedIn Recruiter: Das Professional Tool für Active Sourcing</strong><br/>
                  LinkedIn Recruiter ist das Premium-Tool für professionelles Active Sourcing auf LinkedIn. Als Social Recruiting Agentur nutzen wir LinkedIn Recruiter für unsere Kunden und können dadurch deutlich effektiver arbeiten als mit dem Standard-Account. Die Vorteile umfassen: Erweiterte Suchfilter und Boolean Search, unbegrenzte InMail-Credits für die Kandidatenansprache, Projektverwaltung und Team-Collaboration, erweiterte Insights zu Kandidaten und deren Karriereverläufen, und Integration mit Bewerbermanagementsystemen.
                </span>
                <br></br>
                <br></br>
                <span>
                  LinkedIn Recruiter ermöglicht es, sehr spezifische Kandidatensuchen durchzuführen. Sie können nach "Years in Current Position" filtern (z.B. Kandidaten, die schon länger beim aktuellen Arbeitgeber sind und vielleicht wechselbereit wären), nach Mitgliedschaften in bestimmten LinkedIn-Gruppen, nach Kandidaten in bestimmten Unternehmen oder nach Menschen, die vor kurzem Beiträge zu bestimmten Themen gepostet haben. Diese granularen Filter ermöglichen hochpräzise Suchen, die mit normalen LinkedIn-Accounts nicht möglich sind.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>InMail-Strategie: Wie Sie die höchste Response-Rate erzielen</strong><br/>
                  InMails sind LinkedIn's Nachrichtensystem für die Kontaktaufnahme mit Personen außerhalb Ihres Netzwerks. Als Social Recruiting Agentur haben wir über Jahre hinweg InMail-Strategien entwickelt und optimiert. Die durchschnittliche InMail Response-Rate liegt bei etwa 10-25%, abhängig von Branche, Position und Qualität der Ansprache. Mit unseren optimierten Ansätzen erreichen wir regelmäßig Response-Raten von 30-40% oder mehr.
                </span>
                <br></br>
                <br></br>
                <span>
                  Der Betreff ist entscheidend – Kandidaten entscheiden oft binnen Sekunden, ob sie eine InMail öffnen. Erfolgreiche Betreffs sind: konkret und relevant ("Senior Python Developer Position bei [Unternehmensname]"), personalisiert ("Ihre Expertise in Machine Learning"), neugierweckend ohne clickbait zu sein, und kurz (unter 50 Zeichen). Vermeiden Sie generische Betreffs wie "Spannende Karrierechance" oder "Wir suchen Sie" – diese werden ignoriert.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>LinkedIn Talent Insights: Datengetriebenes Active Sourcing</strong><br/>
                  LinkedIn Talent Insights ist ein Analytics-Tool, das wertvolle Daten über den Talentpool liefert. Als Social Recruiting Agentur nutzen wir diese Daten für strategisches Active Sourcing: Wo sind die meisten Kandidaten mit bestimmten Skills? Welche Unternehmen verlieren gerade Mitarbeiter (und sind deshalb gute Sourcing-Targets)? Welche Skills sind in Ihrer Region besonders gefragt? Wie entwickeln sich Talent-Trends in Ihrer Branche?
                </span>
                <br></br>
                <br></br>
                <span>
                  Diese Insights helfen, Active Sourcing strategischer anzugehen. Statt blind zu suchen, können Sie gezielt Unternehmen, Regionen oder Profile targetieren, wo Sie die höchste Erfolgswahrscheinlichkeit haben. Auch Gehaltserwartungen und Benefits-Präferenzen können aus LinkedIn Talent Insights abgeleitet werden, was Ihnen hilft, attraktive Angebote zu formulieren.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Social Recruiting vs. Active Sourcing auf LinkedIn</strong><br/>
                  Es ist wichtig, zwischen Social Recruiting und Active Sourcing auf LinkedIn zu unterscheiden, auch wenn beide oft Hand in Hand gehen. Social Recruiting umfasst alle Recruiting-Aktivitäten auf Social Media – von Employer Branding über Stellenanzeigen bis zu Active Sourcing. Active Sourcing ist speziell die proaktive Direktansprache. Optimal ist die Kombination: Während Sie durch Active Sourcing gezielt Kandidaten ansprechen, bauen Sie parallel durch Social Recruiting (Employer Branding Posts, Company Updates, Employee Advocacy) eine starke Arbeitgebermarke auf, die Kandidaten empfänglicher für Ihre Ansprache macht.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('LinkedIn Strategie')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">LinkedIn Strategie entwickeln →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="LinkedIn Active Sourcing"
              src="/social-media-recruiting-agentur-linkedin.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section12">
        <header className="home-header11">
          <h2 className="home-text25">Follow-up & Relationship Building: Aus Kontakten werden Bewerber</h2>
          <span className="home-text26">
            Die erste Ansprache ist nur der Anfang. Als Social Recruiting Agentur in Berlin wissen wir: Erfolgreiches Active Sourcing erfordert professionelles Follow-up und langfristigen Beziehungsaufbau.
          </span>
        </header>
        
        <section className="home-note2">
          <div className="home-image19">
            <img
              alt="Follow-up Strategie"
              src="/social-media-recruiting-agentur-ads.png"
              className="home-image20"
            />
          </div>
          <div className="home-content3">
            <div className="home-main3">
              <div className="home-caption3">
                <span className="section-head">Strukturiertes Follow-up</span>
              </div>
              <div className="home-heading12">
                <h2 className="section-heading">
                  Wie Sie aus erstem Interesse konkrete Bewerbungen machen
                </h2>
                <p className="section-description">
                  Viele Kandidaten antworten nicht sofort auf die erste Active Sourcing Nachricht. Das heißt nicht, dass sie nicht interessiert sind – oft ist einfach der Zeitpunkt nicht passend, oder sie brauchen mehr Informationen, bevor sie sich festlegen. Als Social Recruiting Agentur haben wir strukturierte Follow-up Prozesse entwickelt, die Response-Raten deutlich erhöhen. Der Schlüssel liegt im richtigen Timing und der richtigen Anzahl von Follow-ups.
                  
                  Unser bewährtes Follow-up Schema: Erste Ansprache erfolgt über InMail oder andere Kanäle. Nach 4-7 Tagen ohne Antwort: Erstes Follow-up mit zusätzlichen Informationen oder neuem Aufhänger ("Ich wollte noch ergänzen..." oder "Vielleicht interessiert Sie auch..."). Nach weiteren 7-10 Tagen: Zweites Follow-up, eventuell über einen anderen Kanal (wenn erste Ansprache über LinkedIn war, versuchen Sie Email). Nach weiteren 2-3 Wochen: Finales Follow-up mit klarem Zeitlimit ("Ich versuche es ein letztes Mal...").
                  
                  Wichtig ist, dass Follow-ups nie drängend oder verzweifelt wirken. Sie bieten Mehrwert, zeigen echtes Interesse am Kandidaten und respektieren dessen Zeit und Situation. Als Social Recruiting Agentur formulieren wir Follow-ups, die Kandidaten nicht nerven, sondern sanft am Gespräch halten und Interesse wach halten.
                </p>
              </div>
            </div>
            <div className="home-get-started3 button" onClick={() => openContactModal('Follow-up Prozess')} style={{ cursor: 'pointer' }}>
              <span className="home-text27">Follow-up Prozess entwickeln</span>
            </div>
          </div>
        </section>

        <section className="home-note3">
          <div className="home-image21">
            <img
              alt="Talent Pool Management"
              src="/social-media-recruiting-agentur-mittelstand.png"
              className="home-image22"
            />
          </div>
          <div className="home-content4">
            <main className="home-main4">
              <header className="home-caption4">
                <span className="home-section14 section-head">
                  Talent Pool Aufbau
                </span>
              </header>
              <main className="home-heading14">
                <header className="home-header12">
                  <h2 className="section-heading">
                    Langfristiger Beziehungsaufbau für zukünftige Positionen
                  </h2>
                  <p className="section-description">
                    Nicht jeder angesprochene Kandidat ist sofort wechselbereit. Viele sind grundsätzlich interessiert, aber der Zeitpunkt passt nicht – vielleicht läuft gerade ein spannendes Projekt, oder sie haben erst kürzlich gewechselt. Diese Kandidaten sind wertvoll für Ihren Talent Pool. Als Social Recruiting Agentur helfen wir Ihnen, einen strategischen Talent Pool aufzubauen – ein Netzwerk von Kandidaten, die Sie bei zukünftigen Positionen kontaktieren können.
                    
                    Talent Pool Management bedeutet, Beziehungen zu potenziellen Kandidaten zu pflegen, auch wenn aktuell keine passende Position offen ist. Dies geschieht durch: Regelmäßige, wertvolle Updates zu Ihrem Unternehmen (neue Projekte, Erfolge, Entwicklungen), Einladungen zu Networking-Events oder Webinaren, Content-Sharing zu relevanten Branchenthemen, persönliche Check-ins alle paar Monate. Diese "Nurturing"-Strategie hält Sie im Gedächtnis der Kandidaten und erhöht die Wahrscheinlichkeit, dass sie sich bei der nächsten passenden Gelegenheit bei Ihnen bewerben.
                    
                    CRM-Systeme sind für professionelles Talent Pool Management unerlässlich. LinkedIn Recruiter bietet Projektmanagement-Funktionen, aber dedizierte Recruiting-CRMs wie Workday, Greenhouse oder Personio bieten erweiterte Möglichkeiten. Als Social Recruiting Agentur implementieren und managen wir diese Systeme für Sie und stellen sicher, dass kein vielversprechender Kandidat verloren geht.
                  </p>
                </header>
                <div className="home-checkmarks">
                  <Mark label="Strukturierter Talent Pool Aufbau und Management"></Mark>
                  <Mark label="CRM-basiertes Kandidaten-Tracking"></Mark>
                  <Mark label="Langfristige Beziehungspflege und Nurturing"></Mark>
                </div>
              </main>
            </main>
            <div className="home-get-started4 button" onClick={() => openContactModal('Talent Pool aufbauen')} style={{ cursor: 'pointer' }}>
              <span className="home-text28">Talent Pool aufbauen</span>
            </div>
          </div>
        </section>
      </section>

      <section className="home-section15">
        <header className="home-header13">
          <header className="home-left1">
            <span className="section-head">Unsere Active Sourcing Expertise</span>
            <h2 className="section-heading">
              <span>Warum Unternehmen aus Berlin und ganz Deutschland</span>
              <br></br>
              <span>auf unsere Active Sourcing Expertise vertrauen</span>
            </h2>
          </header>
          <div className="home-right1">
            <p className="home-paragraph4 section-description">
              Als spezialisierte Social Recruiting Agentur in Berlin haben wir hunderte erfolgreiche Active Sourcing Projekte umgesetzt. Von IT über Engineering bis Healthcare – wir finden die richtigen Kandidaten für jede Position.
            </p>
          </div>
        </header>
      </section>

      <section className="home-section11">
        <h2 className="home-text12">
          Active Sourcing Erfolgsmessung: KPIs und Best Practices
        </h2>
        <div className="home-note1">
          <div className="home-content2">
            <main className="home-main2">
              <h2 className="home-heading11">
                Wie Sie den Erfolg Ihrer Active Sourcing Aktivitäten messen
              </h2>
              <p className="home-paragraph1">
                <span>
                  Active Sourcing muss messbar sein, um kontinuierlich optimiert werden zu können. Als Social Recruiting Agentur tracken wir für jeden Kunden detaillierte KPIs und berichten transparent über Erfolge und Optimierungspotenziale. Die wichtigsten Active Sourcing KPIs umfassen: <strong>Response Rate:</strong> Wie viele angesprochene Kandidaten antworten auf Ihre InMails oder Nachrichten? Eine gute Response Rate liegt bei 20-40%, abhängig von Branche, Position und Qualität der Ansprache. Eine niedrige Response Rate deutet auf Probleme mit der Ansprache, dem Targeting oder der Attraktivität Ihrer Position hin.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Interest Rate:</strong> Wie viele der antwortenden Kandidaten zeigen echtes Interesse an der Position (vs. höfliche Absagen)? Die Interest Rate zeigt, wie gut Ihr Targeting ist – sprechen Sie die richtigen Kandidaten an? <strong>Conversion Rate:</strong> Wie viele interessierte Kandidaten kommen tatsächlich in den Bewerbungsprozess (Telefon-Interview, persönliches Gespräch, etc.)? Eine niedrige Conversion Rate kann auf Probleme im Interview-Prozess oder unrealistische Kandidatenerwartungen hindeuten.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Hire Rate:</strong> Wie viele durch Active Sourcing gefundene Kandidaten werden letztendlich eingestellt? Dies ist die ultimative Erfolgskennzahl. <strong>Time to Hire:</strong> Wie lange dauert es von der ersten Active Sourcing Ansprache bis zur erfolgreichen Einstellung? Active Sourcing kann diesen Prozess erheblich beschleunigen, da Sie nicht auf Bewerbungen warten müssen. <strong>Cost per Hire:</strong> Was kostet Sie eine erfolgreiche Einstellung durch Active Sourcing? Dies umfasst Tool-Kosten (LinkedIn Recruiter etc.), Zeitaufwand und eventuell Agentur-Fees.
                </span>
                <br></br>
                <br></br>
                <span>
                  <strong>Quality of Hire:</strong> Wie gut performen die durch Active Sourcing eingestellten Mitarbeiter im Vergleich zu durch andere Kanäle gefundenen Mitarbeitern? Studien zeigen oft, dass Active Sourcing Kandidaten tendenziell besser performen, da sie gezielt ausgewählt und aktiv überzeugt wurden. <strong>Channel Performance:</strong> Welche Sourcing-Kanäle (LinkedIn, XING, GitHub, etc.) liefern die besten Ergebnisse? Diese Analyse hilft, Ressourcen optimal zu verteilen.
                </span>
                <br></br>
                <br></br>
                <span>
                  Als Social Recruiting Agentur nutzen wir diese KPIs für kontinuierliche Optimierung. Wir testen verschiedene Ansprache-Varianten (A/B-Testing), optimieren Suchstrings für besseres Targeting, verfeinern unsere Candidate Personas basierend auf Erfolgen und Misserfolgen, und passen unsere Strategie an Marktveränderungen an. Durch diesen datengetriebenen Ansatz verbessern wir kontinuierlich die Ergebnisse unserer Active Sourcing Aktivitäten.
                </span>
              </p>
            </main>
            <div className="home-explore-more" onClick={() => openContactModal('KPI-Tracking einrichten')} style={{ cursor: 'pointer' }}>
              <p className="home-text24">KPI-Tracking einrichten →</p>
            </div>
          </div>
          <div className="home-image17">
            <img
              alt="Active Sourcing KPIs"
              src="/social-media-recruiting-agentur-wichtig.png"
              className="home-image18"
            />
          </div>
        </div>
      </section>

      <section className="home-section19">
        <div className="home-cube1">
          <div className="home-top1 side"></div>
          <div className="home-front1 side"></div>
          <div className="home-left2 side"></div>
        </div>
        <main className="home-banner">
          <div className="home-header15">
            <h2 className="section-heading">
              Starten Sie jetzt mit professionellem Active Sourcing
            </h2>
            <p className="home-description1 section-description">
              Lassen Sie uns die besten Talente für Ihr Unternehmen finden – bevor Ihre Konkurrenz es tut!
            </p>
          </div>
          <div className="home-buttons2">
            <div className="home-get-started5 button" onClick={() => openContactModal('Active Sourcing beauftragen')} style={{ cursor: 'pointer' }}>
              <span className="home-text32">Active Sourcing beauftragen</span>
            </div>
          </div>
        </main>
      </section>

      <section className="home-section26">
        <header className="home-header22">
          <span className="section-head">FAQ</span>
          <h2 className="home-heading26 section-heading">
            Häufig gestellte Fragen zu Active Sourcing
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="fa-qroot-class-name"></FAQ>
        </main>
      </section>

      <section className="home-section28">
        <main className="home-content6">
          <header className="home-header23">
            <h2 className="home-heading27 section-heading">
              Bereit für proaktive Kandidatenansprache? Kontaktieren Sie uns!
            </h2>
            <div className="home-buttons3">
              <div className="home-ios button" onClick={() => openContactModal('Active Sourcing starten')} style={{ cursor: 'pointer' }}>
                <span className="home-text50">Jetzt Active Sourcing starten</span>
              </div>
            </div>
          </header>
          <img
            alt="Active Sourcing Berlin"
            src="/social-media-recruiting-agentur-bereit.png"
            className="home-image25"
          />
        </main>
      </section>

      <Footer activePage="active-sourcing" />

      <ContactModal isOpen={isContactModalOpen} onClose={closeContactModal} buttonSource={buttonSource} />
    </div>
  )
}

export default ActiveSourcing